<template>
  <div class="ti-skeleton-loader">
    <div class="ti-skeleton-loader__section">
      <wb-skeleton></wb-skeleton>
    </div>

    <div class="ti-skeleton-loader__section">
      <wb-skeleton></wb-skeleton>
      <wb-skeleton></wb-skeleton>
      <wb-skeleton></wb-skeleton>
    </div>

    <div class="ti-skeleton-loader__section">
      <wb-skeleton></wb-skeleton>
    </div>
  </div>
</template>

<style lang="scss" src="./skeleton-loader.scss"></style>
